// extracted by mini-css-extract-plugin
export default {"zoomControls":"Sba-z","zoomControlButton":"Tba-z","zoomBanner":"Uba-z","bannerButton":"Vba-z","imageButton":"Wba-z","zoom":"Xba-z","zoomContent":"Yba-z"};